export default __webpack_public_path__ + "43da782d27bd183726f2a56a9931b1a0.png";